import { render, staticRenderFns } from "./newAccount.vue?vue&type=template&id=4c2f3989&scoped=true"
import script from "./newAccount.vue?vue&type=script&lang=js"
export * from "./newAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c2f3989",
  null
  
)

export default component.exports